import filterXSS from 'xss';

(() => {
    $(document).ready(function () {
        if ($('.see-all').length) {
            $('.see-all').each(function () {
                if (!$(this).prev('.hidden-listing-nav').length) {
                    $(this).remove();
                }
            });

            $('.see-all').on('click', function (e) {
                e.preventDefault();
                let nextText = $(this).data('toggle-text');
                let currentText = $(this).text();

                $(this).find('span b').text(nextText);
                $(this).data('toggle-text', currentText);

                $(this).prev('.hidden-listing-nav').toggle('fast');
            });
        }

        if ($('.listing-filter').length) {
            $('.listing-filter').on('click', function (e) {
                e.preventDefault();
                $('.listing-nav-wrap').toggleClass('d-none');
            });
        }

        // Insights Listing
        // Checkbox Filters
        var listURL = '//' + window.location.hostname + window.location.pathname,
            paramPull = function (eventType) {
                var newParams = [],
                    queryString = '';

                $.each(window.location.search.replace(/\?/g, '').split('&'), function (key, value) {
                    var filterParts = value.split('=');
                    if (filterParts[0] != 'type' && filterParts[0] != 'page') {
                        newParams.push(filterXSS(value));
                    }
                });

                if (eventType != 'clear') {
                    $('.listing-nav-block .checkbox').each(function () {
                        var title = $(this).closest('li').find('label').data('title');

                        if ($(this).is(':checked')) {
                            var strTitle = title.replace(/\s+/g, '-');

                            newParams.push('type=' + strTitle);
                        }
                    });
                }

                if (newParams.length > 0) {
                    queryString = '?' + newParams.join('&');
                }

                window.location.href = listURL + queryString;
            };

        $('.listing-nav-block .checkbox').on('change', function () {
            paramPull('change');
        });

        $('.clear-listing').on('click', function () {
            paramPull('clear');
        });
    });
})();
